module.exports = __webpack_public_path__ + "static/assets/60ce4ffdb2c0360cb62e4fbab69ec09c.png";